// GR VAT (ΑΦΜ) lookup — talks to the SAME endpoint the classic checkout uses
// (timologia-for-woocommerce: wp_ajax_timologio_for_wc_aade_fill). We only
// reuse the transport + response contract here; no AADE logic is duplicated.
//
// Response shapes the endpoint can return (see wc-timologia.php::check_for_valid_vat_aade):
//   - active business : { onomasia, doy_descr, postal_address, postal_address_no,
//                          postal_area_description, postal_zip_code, activities:[...], ... }
//   - inactive/ceased : { inactive:true, message, deactivation_flag_descr, ... }
//   - not found       : false            (JSON literal, or legacy "false" string)
//   - AADE outage     : ['error']
//   - empty/skipped   : []               (non-GR prefix or bad length)

const cfg = (typeof window !== 'undefined' && window.CHECKOUT_NEXT) || {};

// Normalise the raw AADE record into the flat set of _billing_* values the
// classic checkout writes (script3.js), so downstream steps can submit the
// exact same fields WooCommerce already expects.
function mapToBilling(r) {
  const addressNo = (r.postal_address_no || '').toString().trim();
  const address1 = [r.postal_address, addressNo].filter(Boolean).join(' ').trim();
  return {
    billing_company: r.onomasia || '',
    billing_irs: r.doy_descr || '',                       // ΔΟΥ
    billing_store: (r.activities && r.activities[0]) || '', // δραστηριότητα
    billing_address_1: address1,
    billing_city: r.postal_area_description || '',
    billing_postcode: r.postal_zip_code || '',
  };
}

// Human-readable "Έδρα" (registered seat) built from the address parts.
export function formatEdra(billing) {
  const line = billing.billing_address_1 || '';
  const tail = [billing.billing_postcode, billing.billing_city].filter(Boolean).join(' ');
  return [line, tail].filter(Boolean).join(', ');
}

// Returns one of:
//   { status: 'valid',    billing, raw }
//   { status: 'inactive', message }
//   { status: 'notfound' }
//   { status: 'error' }       (AADE down / network)
export async function lookupAfm(digits) {
  const body = new URLSearchParams();
  body.set('action', 'timologio_for_wc_aade_fill');
  body.set('vat', digits);

  const res = await fetch(cfg.ajaxUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: body.toString(),
  });

  let data;
  try {
    data = await res.json();
  } catch (e) {
    return { status: 'error' };
  }

  // Inactive / ceased business.
  if (data && data.inactive) {
    const msg = (data.message || '').toString().trim()
      || ('Το ΑΦΜ δεν είναι ενεργό στο μητρώο της ΑΑΔΕ'
          + (data.deactivation_flag_descr ? ': ' + data.deactivation_flag_descr : '') + '.');
    return { status: 'inactive', message: msg };
  }

  // AADE outage — endpoint returns ['error'].
  if (Array.isArray(data) && data[0] === 'error') {
    return { status: 'error' };
  }

  // Not found — literal false or legacy "false" string.
  if (data === false || data === 'false' || typeof data === 'string') {
    return { status: 'notfound' };
  }

  // Empty/unknown shape (e.g. [] for skipped) or missing company name.
  if (!data || !data.onomasia) {
    return { status: 'notfound' };
  }

  return { status: 'valid', billing: mapToBilling(data), raw: data };
}
